import { Modal } from "antd";
import "./CustomModal.scss";

const CustomModal = ({ content, closeIcon = null, ...props }) => {
  return (
    <Modal closeIcon={closeIcon} footer={null} className="custom-modal" {...props}>
      {content}
    </Modal>
  );
};

export default CustomModal;
